/**
 * Profile's five sections and the fixtures they render until the account API
 * exists. The section list lives here rather than in ProfileNav so the layout's
 * nav and its phone-width SectionPicker read the same array — same shape the
 * Affiliate and Payout asides use, `{ to, label, icon, end? }`.
 */
export const SECTIONS = [
  { to: '/profile', label: 'My Profile', icon: 'profile-user', end: true },
  { to: '/profile/password', label: 'Password', icon: 'profile-password' },
  { to: '/profile/tradelocker', label: 'TradeLocker Info', icon: 'profile-platform' },
  { to: '/profile/dxtrade', label: 'DX Trade Info', icon: 'profile-platform' },
  { to: '/profile/security', label: '2FA', icon: 'profile-2fa' },
];

/**
 * Personal details. `phoneCode` is kept apart from `phone` because NumberInput
 * owns the dial-code picker and reports the two separately, the same split
 * TradingAssessment's customer form uses.
 */
export const PROFILE = {
  firstName: 'Jetmir',
  lastName: 'Kojqiqi',
  email: 'jetmir@alphacapital.com',
  phone: '7324464213',
  phoneCode: '+44',
  country: 'GB',
  city: 'London',
  dob: '1994-06-13',
};

/** Last successful password change — the note under the Password form. */
export const PASSWORD_CHANGED_AT = '12 Aug 2026';

/**
 * The two platforms the funded accounts run on. Metadata only — the
 * credentials themselves come from `getPlatformCredentials`, which returns
 * them keyed by these same ids.
 */
export const PLATFORMS = {
  tradelocker: {
    id: 'tradelocker',
    name: 'TradeLocker',
    blurb:
      'Credentials for every TradeLocker account on your profile. Use them to sign in to the web terminal — they are not your Alpha Capital login.',
    web: 'https://live.tradelocker.com',
  },
  dxtrade: {
    id: 'dxtrade',
    name: 'DX Trade',
    blurb:
      'Credentials for every DX Trade account on your profile. Use them to sign in to the DX Trade terminal — they are not your Alpha Capital login.',
    web: 'https://dxtrade.alphacapitalgroup.uk',
  },
};
